import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { currencySymbol, formatPrice } from '../../services/CurrencyUtils';
import { PlanFeatureText } from './PlanFeatureText.tsx';

export class PlanTile extends Component {
  renderFeatureList = features => features.map(featureText => (
    <li key={featureText}>
      <PlanFeatureText>{featureText}</PlanFeatureText>
    </li>
  ))

  tileClassNames = () => {
    let classNames = 'planTile';
    if (this.props.selected) {
      classNames += ' planTile_Selected';
    }
    return classNames;
  }

  buttonText = () => {
    const { t } = this.props;

    return this.props.selected ? t('plan_select_form.selected_button_label') : t('plan_select_form.select_button_label');
  }

  render() {
    const {
      name, price, effectiveMonthlyPrice, interval, currency, features, t,
    } = this.props;

    return (
      <div className={this.tileClassNames()}>
        <div>
          <p className="planTile_Title">{name}</p>
          <p className="planTile_Price">
            <span className="planTile_Price_Dollar">{currencySymbol(currency)}</span>
            {formatPrice(effectiveMonthlyPrice)}
          </p>
          <p className="planTile_Frequency">/{t('plan_select_form.interval_per_month_title')}</p>
          {interval === 'annually' ? (
            <p>
              {t(
                'plan_select_form.billing_description_annual',
                {
                  currencySymbol: currencySymbol(currency),
                  amount: formatPrice(price),
                },
              )}
            </p>
          ) : null}
        </div>
        <div className="planTile_Features">
          <ul>
            {this.renderFeatureList(features)}
          </ul>
        </div>
        <div className="planTile_Buttons">
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.props.onSelect}
            disabled={this.props.selected}>
          {this.buttonText()}
          </button>
        </div>
      </div>
    );
  }
}

export default withTranslation('activation_wizard')(PlanTile);
